import React from 'react';
import '../scss/components/_modal.scss'

const Modal = ({ handleClose, show, children, className}) => {
    const showHideClassName = show ? "modal d-block" : "modal d-none";
  
    return (
      <div className={showHideClassName + ' ' + className}>
        <div className={"modal-main " + className} >
          <div className={"close-button " + className}>
            <img alt="Close Modal" src="/pricing/icons/close-modal.svg" onClick={handleClose}/>
          </div>
          {children}
        </div>
      </div>
    );
  };

export default Modal;